import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

interface BaseCurveEdgeEffectThicknessOptionProps {
  edgeThickness: number;
  onUpdateThickness(value: number, undoable?: boolean): void;
}

export function BaseCurveEdgeEffectThicknessOption({...props}: BaseCurveEdgeEffectThicknessOptionProps): ReactElement<any> | null {
  const onChangeEdgeThickness = (edgeThickness: number): void => {
    props.onUpdateThickness(edgeThickness, false);
  };

  const onChangeEdgeThicknessEnded = (edgeThickness: number): void => {
    props.onUpdateThickness(edgeThickness, true);
  };
  return (
    <ContextualMenuSliderOptions
      id="item-curve-amount"
      value={props.edgeThickness}
      label={window.i18next.t('pmwjs_radius')}
      range={{
        min: 0,
        max: 28,
      }}
      transformDisplay={{
        min: 0,
        max: 100,
      }}
      addDelayToOnChange
      delayForOnChange={350}
      onChange={onChangeEdgeThickness}
      onChangeEnded={onChangeEdgeThicknessEnded}
    />
  );
}
